import { CountryItem } from '../types';

const getCodeByISOCode = (
  items: CountryItem[] = [],
  value: string
): string | undefined => items.find((i) => i.iso1Code === value)?.phoneCode;

export default getCodeByISOCode;
